export default __webpack_public_path__ + "static/media/icon-assessment.8245a98c.svg";